var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSeveral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.509 14.5C14.509 14.617 14.509 14.698 14.509 14.788C14.509 15.85 14.509 16.912 14.509 17.974C14.509 18.64 14.149 19 13.501 19C9.676 19 5.851 19 2.026 19C1.351 19 1 18.649 1 17.983C1 14.158 1 10.333 1 6.508C1 5.851 1.36 5.5 2.026 5.5C3.088 5.5 4.15 5.5 5.212 5.5H5.5V5.239C5.5 4.168 5.5 3.097 5.5 2.035C5.491 1.351 5.842 1 6.517 1C10.333 1 14.158 1 17.974 1C18.658 1 19 1.342 19 2.026C19 5.842 19 9.667 19 13.483C19 14.158 18.649 14.509 17.974 14.509C16.912 14.509 15.85 14.509 14.788 14.509C14.707 14.509 14.626 14.509 14.509 14.509V14.5ZM14.509 12.682H17.191V2.809H7.318V5.5H7.588C9.532 5.5 11.485 5.5 13.429 5.5C14.158 5.5 14.509 5.851 14.509 6.571C14.509 8.524 14.509 10.477 14.509 12.43C14.509 12.511 14.509 12.592 14.509 12.691V12.682ZM3.7 12.214C4.753 13.267 5.806 14.32 6.841 15.355C8.524 13.672 10.216 11.98 11.881 10.315C11.476 9.91 11.062 9.496 10.621 9.055C9.37 10.306 8.11 11.566 6.814 12.871C6.184 12.232 5.563 11.602 4.942 10.972C4.519 11.395 4.105 11.809 3.691 12.214H3.7Z",
    fill: "#FFCD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSeveral);
export default __webpack_public_path__ + "static/media/CheckSeveral.db01ca38832db76bc34c0b09bdc1879c.svg";
export { ForwardRef as ReactComponent };